import { axiosWithAuth } from "helpers";

export const sourceFilesService = {
	uploadFiles,
	getSourceFiles,
	deleteSourceFile,
	editSourceFile,
	importSourceFiles,
};

const RESIDUALS_API_URL = process.env.REACT_APP_API_URL_RESIDUALS;

function uploadFiles(files, paidYear, paidMonth) {
	const formData = new FormData();
	const file = files.document;
	const [fileName, extension = ""] = file.name.split(".");

	formData.append("file", file);
	formData.append("name", fileName);
	formData.append("extension", extension);
	formData.append("source_type", parseInt(files.sourceType));
	formData.append("processing_year", parseInt(files.processingYear));
	formData.append("processing_month", parseInt(files.processingMonth));

	return axiosWithAuth({
		method: "POST",
		data: formData,
		url: `${RESIDUALS_API_URL}/api/source_files/${paidYear}/${paidMonth}`,
		headers: { "Content-Type": undefined },
	});
}

function getSourceFiles({ status, filtersApplied }) {
	const filter = {
		paid_month: filtersApplied.paidMonth,
		paid_year: filtersApplied.paidYear,
		search_for: filtersApplied.searchFor,
	};
	return axiosWithAuth({
		method: "GET",
		params: { ...filter, status },
		url: `${RESIDUALS_API_URL}/api/source_files`,
	});
}

function deleteSourceFile(id) {
	return axiosWithAuth({
		method: "DELETE",
		url: `${RESIDUALS_API_URL}/api/source_files/${id}`,
	});
}

function editSourceFile({ id, reconciliationCheck }) {
	return axiosWithAuth({
		method: "PATCH",
		data: [
			{
				value: reconciliationCheck,
				path: "/reconciliation_status",
				op: "replace",
			},
		],
		url: `${RESIDUALS_API_URL}/api/source_files/${id}`,
		headers: { "Content-Type": "application/json-patch+json" },
	});
}

function importSourceFiles(id) {
	return axiosWithAuth({
		method: "POST",
		url: `${RESIDUALS_API_URL}/api/source_files/${id}/import`,
	});
}
